import { useAuth } from '../contexts/AuthContext';

export const useApi = () => {
  const { getAccessToken } = useAuth();
  const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8889';

  const fetchWithAuth = async (endpoint: string, options: RequestInit = {}) => {
    try {
      const token = await getAccessToken();
      
      // Create headers that won't interfere with FormData boundaries
      // Don't manually set Content-Type for FormData as the browser needs to set it with the boundary
      const headers: HeadersInit = {};
      if (!(options.body instanceof FormData)) {
        headers['Content-Type'] = 'application/json';
      }
      
      // Add authorization header
      headers['Authorization'] = `Bearer ${token}`;
      
      // Merge with any existing headers, but prefer our generated ones
      const finalHeaders = {
        ...options.headers,
        ...headers
      };

      // Log the actual request being made
      console.log(`Sending ${options.method || 'GET'} request to: ${baseUrl}${endpoint}`);
      
      const response = await fetch(`${baseUrl}${endpoint}`, {
        ...options,
        headers: finalHeaders,
      });

      if (!response.ok) {
        // Try to get error details if possible
        let errorDetails;
        try {
          errorDetails = await response.text();
        } catch (e) {
          errorDetails = 'No error details available';
        }
        
        console.error(`API request failed (${response.status}): ${errorDetails}`);
        throw new Error(`API request failed (${response.status}): ${errorDetails}`);
      }

      return response.json();
    } catch (error) {
      console.error('API request error:', error);
      throw error;
    }
  };

  return { fetchWithAuth };
}; 